import React from "react";
import Wrapper from "../Wrapper/Wrapper";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "../Layout/theme";
import { CssBaseline } from "@material-ui/core";
import { connectUserStore } from "../connectStore/connectUserStore";
import ThemeRtl from "../Layout/ThemeRtl";

class ThemeLink extends React.Component {
  render() {
    return (
      <Wrapper>
        <ThemeRtl>
          <ThemeProvider theme={theme}>
            {this.props.children}
            <CssBaseline />
          </ThemeProvider>
        </ThemeRtl>
      </Wrapper>
    );
  }
}

export default connectUserStore(ThemeLink);
